import React from "react";

import { useTranslation } from "react-i18next";

import { Event } from "@gp/models";

export function EventTags({ event }: { event: Event }) {
	const { t } = useTranslation();

	return (
		<div className="event__top__info">
			{event.hasLiveCoverage && !event.isLive && (
				<span className="event__tag event__tag--live tag tag--tny tag--live--ghost tag--bolder">
					{t("COMMON.LIVE")}
				</span>
			)}
			{event.isTopEvent && (
				<>
					<i className="event__tag event__tag--top u-icon u-icon--sml u-icon--top--str u-color--rate--low" />
					{/* <span className="event__tag event__tag--top tag tag--tny tag--sunny tag--bolder">
						{t("COMMON.TOP_EVENT")}
					</span> */}
				</>
			)}
		</div>
	);
}
